<template>
    <custom-modal
        v-model="modal"
        :modal-title="modalTitle"
        padding="30"
    >
        <form @submit.prevent="save">
            <address-select-detailed
                :country-id.sync="form.countryId"
                :region-id.sync="form.regionId"
                :district-id.sync="form.districtId"
                :aymak-id.sync="form.aymakId"
                :village-id.sync="form.villageId"
                :only-village="onlyVillage"
                :only-region="onlyRegion"
                :required="required"
            />
            <div class="btn-actions">
                <v-btn color="red" type="button" @click="modal=false">{{ $t('cancel') }}</v-btn>
                <v-btn color="green" type="submit">{{ $t('save') }}</v-btn>
            </div>
        </form>
    </custom-modal>
</template>

<script>
import { AddressRegistryService } from '../../_services/address-registry.service'
import { AddressService } from '../../_services/address.service'
import AddressSelectDetailed from './AddressSelectDetailed'

const addressService = new AddressService()
const addressRegistryService = new AddressRegistryService()

export default {
  name: 'AddressSelectDetailedModal',
  components: { AddressSelectDetailed },
  props: {
    value: Boolean,
    onlyVillage: Boolean,
    onlyRegion: Boolean,
    required: Boolean,
    countryId: [Number, String],
    regionId: [Number, String],
    districtId: [Number, String],
    aymakId: [Number, String],
    villageId: [Number, String],
    modalTitle: String,
    fullPath: String,
    addressId: [Number, String],
    saveAddress: Boolean
  },
  data () {
    return {
      modal: this.value,
      form: {
        countryId: this.countryId,
        regionId: this.regionId,
        districtId: this.districtId,
        aymakId: this.aymakId,
        villageId: this.villageId
      }
    }
  },

  watch: {
    value (val) {
      this.modal = val
    },

    modal (val) {
      this.$emit('input', val)
    },
    regionId (id) {
      this.form.regionId = id
    },
    countryId (id) {
      this.form.countryId = id
    },
    districtId (id) {
      this.form.districtId = id
    },
    aymakId (id) {
      this.form.aymakId = id
    },
    villageId (id) {
      this.form.villageId = id
    }
  },
  methods: {
    save () {
      this.$emit('update:countryId', this.form.countryId)
      this.$emit('update:regionId', this.form.regionId)
      this.$emit('update:districtId', this.form.districtId)
      this.$emit('update:aymakId', this.form.aymakId)
      this.$emit('update:villageId', this.form.villageId)
      addressRegistryService.getAteFullPathName(this.form.villageId || this.form.aymakId || this.form.districtId || this.form.regionId)
        .then(data => {
          this.$emit('update:fullPath', data.fullname)
          this.modal = false
          if (this.saveAddress) {
            addressRegistryService.getAteFullPathName(this.form.villageId || this.form.aymakId || this.form.districtId || this.form.regionId, 'kg')
              .then(data1 => {
                addressService.create({ ...this.form, fullAddressKg: data1.fullname, fullAddressRu: data.fullname }).then(data1 => {
                  this.$emit('update:addressId', data1.message)
                })
              })
          }
        })
    }
  }
}
</script>

<style scoped>

</style>
